import { createAction } from "redux-actions";

export const handleProfileSubmit = createAction("HANDLE_PROFILE_SUBMIT");
